<template>
  <div class="index">
    <div class="index-con">
      <!-- <img class="index-img" src="@/assets/images/new-018.jpg" alt="" /> -->
      <div class="router">
        <span>IRADSTM</span> <b>→</b> <span>Membership</span> <b>→</b>
        <span>IRADSTM Fellow</span>
      </div>
      <div class="title">International Drying Symposium (IDS)</div>
      <div class="box">
        <div class="box-title">Latest IDS 2024</div>
        <div class="text">
          During November 22–25, 2024, the 23rd International Drying Symposium (IDS 2024), organized by Jiangnan
          University, was successfully held in Wuxi, China. IDS 2024 attracted more than 500 delegates from 29 different
          countries, including the United States, Canada, India, Australia, etc., participated this conference through
          live presentations or poster presentations. 24 famous/renowned experts from the university and industry made
          wonderful invited keynote reports, more than 360 domestic and foreign reporters made exciting reports and
          poster presentations on research projects, the latest R&D and application achievements as well as the
          development trend of new drying intelligence, etc., The delegates had fruitful exchange dialogues on the hot
          spots and difficulties in the field of drying. 16 leading drying enterprises came to the conference to exhibit
          their newly developed products/equipments and specially set up a tasting area for new products of the
          sponsoring enterprises, which was well received by the domestic and foreign delegates.

        </div>
        <br />

        <!--div class="text text-right">——Professor Arun S. Mujumdar</div-->
        <br />
        <div class="text text-right">
          <a href="https://arunmujumdar.com/ids/ ">https://arunmujumdar.com/ids/ </a>
        </div>
        <div class="box-title">Upcoming IDS Conferences</div>

        <div class="card">
          <div class="card-title">24th International Drying Symposium (IDS 2026)</div>
          <div class="left">
            <p>August 25-28, 2026</p>
            <p>Paris, France</p>
            <br />
            <p>Organizer: Co-organised by CentraleSupélec and AgroParisTech of Paris-Saclay University. </p>
            <p>Venue: Campus CentraleSupélec, Université Paris-Saclay </p>
            <p>E-mail: Under Construction</p>
            <p>Website: Under Construction</p>
          </div>

        </div>
        <div class="box-title">Previous IDS Conferences</div>
        <div class="text text-center">
          <p v-for="(i, num) in list" :key="num">{{ i.label }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          label: "1st IDS (IDS1978): Montreal, Canada,",
        },
        {
          label: "2nd IDS (IDS1980): Montreal, Canada",
        },
        {
          label: "3rd IDS (IDS1982): Birmingham, UK",
        },
        {
          label: "4th IDS (IDS1984): Kyoto, Japan",
        },
        {
          label: "5th IDS (IDS1986): Cambridge, USA",
        },
        {
          label: "6th IDS (IDS1988): Versailles, France",
        },
        {
          label: "7th IDS (IDS1990): Prague, Czechoslovakia",
        },
        {
          label: "8th IDS (IDS1992): Montreal, Canada",
        },
        {
          label: "9th IDS (IDS1994): Gold Coast, Australia",
        },
        {
          label: "10th IDS (IDS1996): Krakow, Poland",
        },
        {
          label: "11th IDS (IDS1998): Halkidiki, Greece",
        },
        {
          label: "12th IDS (IDS2000): Noordwijkerhout, Netherlands",
        },
        {
          label: "13th IDS (IDS2002): Beijing, China",
        },
        {
          label: "14th IDS (IDS2004): Sao Paulo, Brazil",
        },
        {
          label: "15th IDS (IDS2006): Budapest, Hungary",
        },
        {
          label: "16th IDS (IDS2008): Hyderabad, India",
        },
        {
          label: "17th IDS (IDS2010): Magdeburg, Germany",
        },
        {
          label: "18th IDS (IDS2012): Xiamen, China",
        },
        {
          label: "19th IDS (IDS2014): Lyon, France",
        },
        {
          label: "20th IDS (IDS2016): Gifu, Japan",
        },
        {
          label: "21st IDS (IDS2018): Valencia, Spain",
        },
        {
          label: "22nd IDS (IDS2020/2022): Worcester, USA",
        },
        {
          label: "23rd IDS (IDS2024): Wuxi, China",
        },

      ],
    };
  },
};
</script>

<style lang="less" scoped>
.index-con {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 50px;

  .small-title {
    margin: 25px 0;
    font-weight: 600;
  }

  .card {
    padding: 25px 15px;
    box-sizing: border-box;
    position: relative;
    font-weight: 700;
    line-height: 1.9;
    background-color: hsla(0, 0%, 50.2%, 0.05);

    .card-title {
      color: #5b965a;
      margin-bottom: 20px;
    }

    img {
      position: absolute;
      bottom: 30px;
      right: 105px;
      width: auto;
      height: 150px;
    }
  }

  .box {
    padding: 0 100px;
    box-sizing: border-box;
  }

  .text {
    font-size: 16px;
    line-height: 2;
  }

  .text-right {
    text-align: right;
  }

  .text-center {
    width: 400px;
    margin: 0 auto;
  }

  .text-green {
    color: #5b965a;
  }

  .title {
    position: relative;
    padding-bottom: 10px;
    color: #5b965a;
    margin-bottom: 50px;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 30px;

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 580px;
      max-width: 100%;
      height: 6px;
      background-color: #5b965a;
    }
  }

  .box-title {
    text-align: center;
    position: relative;
    padding-bottom: 10px;
    color: #5b965a;
    margin-bottom: 50px;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 30px;
    width: 100%;
    margin-top: 50px;

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 400px;
      max-width: 100%;
      height: 6px;
      background-color: #5b965a;
    }
  }

  .router {
    display: flex;
    margin: 23px 0 31px;
    align-items: center;

    span {
      color: rgba(31, 31, 31, 0.5);
      font-family: Canaro, Arial, sans-serif;
      font-size: 14px;
      line-height: 1.8;
      font-weight: 400;
      white-space: nowrap;
      cursor: pointer;
    }

    b {
      color: #f9b033;
      font-weight: 400;
      margin: 0 10px;
    }

    span:nth-last-of-type(1) {
      color: #333;
    }
  }

  .index-img {
    width: 100%;
    height: auto;
  }
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;

    .title {
      font-size: 20px;
    }

    .box-title {
      font-size: 18px;
    }

    .box {
      padding: 0 10px;
    }

    .text-center {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ids.vue